import React from 'react';
import Media from 'react-media';
import { queries } from 'theme';

const MediaMobile = props => <Media {...props} query={queries.mobile} />;

export default MediaMobile;
